/*/
 * Animated scroll
/*/
	const siteScroll = _ => {
		const scrollElements = document.querySelectorAll('[site-reveal]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is--revealed')
				} else {
					entry.target.classList.remove('is--revealed')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '25px 25px 25px 25px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


	const siteVideos = _ => {
		const scrollElements = document.querySelectorAll('video[data-src]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				const video = entry.target.dataset.src

				if (entry.isIntersecting) {
					entry.target.src = video
					entry.target.play()
				}
			})
		}, {
			threshold: 0,
			rootMargin: '25px 25px 25px 25px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


/*/
 * Animated entrance
/*/
	const siteIntro = (short = false) => {
		const scrollElements = document.querySelectorAll('[site-reveal-intro]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					let count = 0
					let timer = short ? (500 / 100) : (3000 / 100)

					entry.target.classList.add('is--shown')

					const counter = setInterval(() => {
						count++
						entry.target.querySelector('strong').style.setProperty('--percent',`${count}%`)
						entry.target.querySelector('strong').innerHTML = `${count}%`

						if (count == 100) clearInterval(counter)
					}, timer)

					if (!short) {
						entry.target.classList.add('is--content')

						setTimeout(() => {
							entry.target.classList.add('is--compact')
						}, 1000);

						setTimeout(() => {
							entry.target.classList.add('is--phrase')
						}, 2000);

						setTimeout(() => {
							entry.target.classList.add('is--revealed')
						}, 4000);
					} else {
						setTimeout(() => {
							entry.target.classList.add('is--revealed-alt')
						}, 100);
					}
				}
			})
		}, {
			threshold: 0,
			rootMargin: '25px 25px 25px 25px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


/*/
 * Load Trigger
/*/
	window.addEventListener('load', function () {
		setTimeout(() => {
			const transitionMode = window.localStorage.getItem('site_short_transition')

			if (transitionMode) {
				siteIntro(true)
				siteScroll()
				siteVideos()
			} else {
				siteIntro(false)
				siteScroll()
				siteVideos()
			}
		}, 500)

		setTimeout(() => {
			window.localStorage.removeItem('site_short_transition')
		}, 1000)
	})


/*/
 * Site Pages Links
/*/
	const siteBaseUrl = document.documentElement.dataset.baseUrl
	const siteLinks = document.querySelector('#app').querySelectorAll(`[href*="${siteBaseUrl}"]`)

	if (siteLinks.length > 0) {
		siteLinks.forEach(e => {
			e.addEventListener('click', event => {
				if (e.dataset.fancybox) return;

				const url = e.href

				event.preventDefault()

				const sitePageTransition = document.querySelector('[site-reveal-transition]')

				sitePageTransition.classList.add('is--loading')
				window.localStorage.setItem('site_short_transition', true)

				setTimeout(() => {
					window.location = url
				}, 300);
			})
		})
	}

	window.onpopstate = function (event) {
		console.log('TESTE')
	}
